/**
 * La grilla de un mes, de lunes a domingo, con los días del mes anterior y siguiente que completan
 * las semanas. La usan Feriados bancarios (Año · Mes) y el calendario de liquidación (Mes).
 * Fechas en ISO (AAAA-MM-DD), a mediodía UTC para que ningún huso corra el día.
 */
export const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
export const DIAS_SEMANA = ['lun', 'mar', 'mié', 'jue', 'vie', 'sáb', 'dom'];

export interface CeldaMes { dia: string; n: number; delMes: boolean; hoy: boolean; }

/** @param mes0 mes de 0 (enero) a 11 (diciembre). */
export function semanasDe(anio: number, mes0: number, hoy = ''): CeldaMes[][] {
  const primero = new Date(Date.UTC(anio, mes0, 1, 12));
  const ultimo = new Date(Date.UTC(anio, mes0 + 1, 0, 12));
  const lunes = new Date(primero);
  lunes.setUTCDate(lunes.getUTCDate() - ((lunes.getUTCDay() + 6) % 7));
  const semanas: CeldaMes[][] = [];
  for (const l = new Date(lunes); l <= ultimo; l.setUTCDate(l.getUTCDate() + 7)) {
    const s: CeldaMes[] = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(l); d.setUTCDate(d.getUTCDate() + i);
      const iso = d.toISOString().slice(0, 10);
      s.push({ dia: iso, n: d.getUTCDate(), delMes: d.getUTCMonth() === mes0, hoy: iso === hoy });
    }
    semanas.push(s);
  }
  return semanas;
}

/** «octubre 2026». */
export const nombreDelMes = (anio: number, mes0: number): string => `${MESES[mes0]} ${anio}`;
